import React from 'react';
import { FocusZone, FocusZoneDirection, List, Modal, SearchBox } from 'office-ui-fabric-react';
import styled from 'styled-components';
import { Icon } from 'office-ui-fabric-react';
import {
  ChoiceGroup,
  IChoiceGroupOption,
} from 'office-ui-fabric-react/lib/ChoiceGroup';
import ReactDOMServer from 'react-dom/server';
import L, { DivIcon, GeoJSON, LatLng, LatLngBounds, Point } from 'leaflet';
import {
  Circle,
  FeatureGroup,
  Map,
  Marker,
  Polyline,
  TileLayer,
  Polygon, CircleMarker, Pane,
} from 'react-leaflet';
import mapController from 'hoc/mapController';
import {
  IMapSettings,
  IMapSettingsParams,
} from 'views/components/Video/MapComponent';

import { DefaultButton, PrimaryButton, Stack } from 'office-ui-fabric-react';
import { isBetween } from '../../../../../utils/geometry';
import { fitMap } from 'utils/map';
import axios from 'utils/axios';
import { EditControl } from 'react-leaflet-draw';
import circleToPolygon from 'circle-to-polygon';
import { theme } from 'theme';

interface IProps {
  // breadcrumbs: Array<IBreadcrumbItem>;
  // handleUpdateBreadcrumb: (breadcrumb: Array<IBreadcrumbItem>) => void;
  handleChangeMapSettings: (params: IMapSettingsParams) => void;
  mapSettings: IMapSettings;
  onClose?: () => void;
  onAccept?: (geom: any) => void;
  point?: {
    lat: number;
    lon: number;
  };
  tripstops?: any[];
  trajectory?: { lat: number; lon: number }[];
  fillPolygon?: boolean;
  isEditable?: boolean;
  toggleSpinner: (value: boolean) => void;
  value: any;
  isPolygon?: boolean;
  zone?: any
}

enum MapType {
  POINT,
  TRAJECTORY,
  TRAJECTORYSTOPS,
}

interface IState {
  point?: {
    lat: number;
    lon: number;
  };
  trajectory?: { lat: number; lon: number }[];
  tripstops?: any[];
  type: MapType;
  selectedIndex?: number;

  currentStopPoint?: { lat: number; lon: number };
  isEditable: boolean;
  searchValue: string;
  searchAddresses: any[];
  isVisibleSearchResult: boolean;
  selectedAddressCenter?: any[];
  mode: string;
  mapLayers: {
    stops: boolean;
    vehicles: boolean;
    routes: boolean;
    incidents: false;
  };
  coordinates: any;
  startTime?: Date;
  endTime?: Date;
  drawingMode: boolean;
  polygon: any;
}

const StyledModalBody = styled.div`
  width: 600px;
  height: 600px;
  position: relative;
  .leaflet-container {
    width: 100%;
    height: 100%;
  }
`;

const BottomRightPanel = styled.div`
  width: 36px;
  height: 84px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 401;
  position: absolute;
  right: 32px;
  bottom: 36px;
`;

// для кнопки выхода (крестика), при isEditable = false
const TopRightPanel = styled.div`
  width: 36px;
  height: 84px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 401;
  position: absolute;
  right: 32px;
  top: 36px;
`;

const TopLeftPanel = styled.div`
  height: 34px;
  width: 415px;
  top: 21px;
  left: 32px;
  position: absolute;
  z-index: 10;
`;

const SearchResultWrapper = styled.div`
  background: #ffffff;
  max-height: 560px;
  margin-top: 0;
  overflow-y: auto;
  transition: opacity 0.2s ease;
  opacity: 0;
  height: 0;
`;

const SearchResultLine = styled.div`
  line-height: 18px;
  font-size: 14px;
  padding: 10px 16px;
  cursor: pointer;
  border-top: 1px solid #f4f4f4;
  color: #8c8c8c;

  :hover {
    background-color: #f4f4f4;
  }
`;

const BlackText = styled.span`
  color: #333;
  font-weight: 700;
`;

const MapButtonBG = styled.div`
  height: 36px;
  width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.9);
`;

const StopsContainer = styled.div`
  width: 300px;
  height: 100%;
`;

const StopsTitle = styled.div`
  font-size: 24px;
  padding: 10px;
`;

const MapButton = styled.div`
  height: 36px;
  width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const DeleteButton = styled(MapButton as any)`
  position: absolute;
  bottom: 0;
  left: -100%;
  height: 36px;
  width: 36px;
  background: #ffffff;
`;

interface WrapperProps {
  isPanelOpen: boolean;
  isFullscreen?: boolean;
}

const MapWrapper = styled.div<WrapperProps>`
  position: relative;
  z-index: 1;
  left: 0;
  height: 100%;

  .leaflet-container {
    z-index: 0;
    height: ${(props) => (props.isFullscreen ? '100vh !important' : '')};
    width: ${(props) => (props.isFullscreen ? '100% !important' : '')};
  }

  .leaflet-top.leaflet-right {
    display: ${(props) => (props.isPanelOpen ? 'block' : 'none')};
  }

  .leaflet-marker-icon:not(:hover) {
    z-index: 0 !important;
  }
`;

const MarkerMapPoint = (
  disabled?: boolean,
  opacity: number = 1,
  text?: string
) =>
  new DivIcon({
    html: ReactDOMServer.renderToString(
      <svg
        height="28"
        width="28"
        viewBox="0 0 40 40"
        style={{
          transform: 'translateX(-50%) translateY(-50%)',
          left: '50%',
          top: '50%',
          position: 'absolute',
        }}
      >
        <circle
          fill={disabled ? '#808080' : '#56CCF2'}
          stroke="#0300B2"
          strokeWidth={2}
          r="10"
          cx="20"
          cy="20"
          style={{ opacity }}
        />
        {text && (
          <text x="0" y="0" text-anchor="middle" transform="translate(20)">
            <tspan
              x="0"
              text-anchor="middle"
              dy="24"
              style={{ fontSize: '14px' }}
            >
              {text}
            </tspan>
          </text>
        )}
      </svg>
    ),
  });

class MapForm extends React.Component<IProps, IState> {
  mapRef = React.createRef<any>();

  constructor(props: IProps) {
    super(props);
    this.state = {
      point: this.props.point,
      trajectory: this.props.trajectory,
      tripstops: this.props.tripstops ? [...this.props.tripstops] : undefined,
      type: this.props.trajectory
        ? this.props.tripstops
          ? MapType.TRAJECTORYSTOPS
          : MapType.TRAJECTORY
        : MapType.POINT,
      // для карты в режиме "просмотра" при работе с маркерами,
      // отключение нижних кнопок и перемещения маркеров
      isEditable: props.isEditable ?? true,
      searchValue: '',
      searchAddresses: [],
      isVisibleSearchResult: false,
      coordinates: null,
      drawingMode: false,
      mapLayers: {
        stops: true,
        vehicles: false,
        routes: true,
        incidents: false
      },
      mode: '',
      polygon: null,
    };
  }

  _handleKeyDown = (event: KeyboardEvent) => {
    // delete
    if (event.keyCode === 46) {
      if (this.state.type === MapType.POINT && this.state.point) {
        this.setState({ point: undefined });
      }
      if (
        this.state.type === MapType.TRAJECTORY &&
        this.state.selectedIndex !== undefined &&
        this.state.trajectory!.length > this.state.selectedIndex
      ) {
        this.state.trajectory!.splice(this.state.selectedIndex, 1);
        this.setState({
          trajectory: this.state.trajectory,
          selectedIndex: undefined,
        });
      }
    }
  };

  componentDidMount() {
    this.state.isEditable && document.addEventListener('keydown', this._handleKeyDown);
    setTimeout(() => {
      this.fitMap();
    }, 0);
  }

  componentWillUnmount() {
    this.state.isEditable && document.removeEventListener('keydown', this._handleKeyDown);
  }

  fitMap = () => {
    const mapRef: Map | null = this.mapRef.current;
    const { mapSettings } = this.props;
    if (mapRef) {
      if (this.props.value && this.props.zone) {
        this.props.value?.length &&
        fitMap({
          latLng: this.props.value.map((latlng: [number, number]) => ({
            lat: latlng[1],
            lng: latlng[0],
          })),
          map: mapRef,
        })
      } else if (this.props.isPolygon) {
        this.props.value?.length &&
        fitMap({
              latLng: this.props.value.map((latlng: [number, number]) => ({
                lat: latlng[0],
                lng: latlng[1],
              })),
              map: mapRef,
            })
      } else {
        switch (this.state.type) {
        case MapType.POINT:
          return this.props.handleChangeMapSettings({
            center: (this.props.point && new LatLng(this.props.point!.lat, this.props.point!.lon)) || mapSettings.center,
          });
        case MapType.TRAJECTORY:
        case MapType.TRAJECTORYSTOPS:
          return (
            this.props.trajectory &&
            fitMap({
              latLng: this.props.trajectory.map(({ lon, lat }) => ({
                lat,
                lng: lon,
              })),
              map: mapRef,
            })
          );
        }
      }
    }
  };

  handleGetBounds = (event: L.LayerEvent | L.LeafletEvent | L.DragEndEvent) => {
    //const bounds = event.target.getBounds();
    const { handleChangeMapSettings } = this.props;
    handleChangeMapSettings({
      zoom: event.target.getZoom(),
      center: event.target.getCenter(),
    });
  };

  updatePointPosition = (e: any): void => {
    const newPos: LatLng = e.target.getLatLng();
    if (this.state.type === MapType.POINT) {
      this.setState({point: {lat: newPos.lat, lon: newPos.lng}});
    } else {
      this.state.trajectory![e.target.options.index] = {
        lat: newPos.lat,
        lon: newPos.lng,
      };
      this.setState({selectedIndex: e.target.options.index});
    }
  };

  editControl = React.createRef<any>();

  onMapClick = (event: L.LeafletMouseEvent) => {
    if (this.state.type === MapType.POINT) {
      this.setState({
        point: {
          lat: +event.latlng.lat.toFixed(5),
          lon: +event.latlng.lng.toFixed(5),
        },
      });
    } else if (this.state.type === MapType.TRAJECTORY) {
      this.state.trajectory!.push({
        lat: event.latlng.lat,
        lon: event.latlng.lng,
      });
      this.setState({
        trajectory: this.state.trajectory,
        selectedIndex: this.state.trajectory!.length - 1,
      });
    }
  };

  onSelectMarker = (event: L.LeafletMouseEvent) => {
    if (this.state.type === MapType.TRAJECTORY) {
      this.setState({
        selectedIndex: event.target.options.index,
        currentStopPoint: undefined,
      });
    }
  };

  distance = (
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number
  ): number => {
    const R = 6371; // km (change this constant to get miles)
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  getPointOnTrajectory = (
    trajectory: { lat: number; lon: number }[],
    distance: number = 0
  ): [number, number] => {
    if (trajectory.length < 2) return [0, 0];
    let clength = 0;
    let ll = 0;
    let i = 1;
    for (i = 1; i < trajectory.length; ++i) {
      ll = this.distance(
        trajectory[i - 1].lat,
        trajectory[i - 1].lon,
        trajectory[i].lat,
        trajectory[i].lon
      );
      if (clength + ll >= distance || i === trajectory.length - 1) {
        break;
      } else {
        clength += ll;
      }
    }
    if (distance >= clength + ll) {
      return [trajectory[i].lat, trajectory[i].lon];
    }
    const ratio = (distance - clength) / ll;
    return [
      trajectory[i - 1].lat * (1 - ratio) + ratio * trajectory[i].lat,
      trajectory[i - 1].lon * (1 - ratio) + ratio * trajectory[i].lon,
    ];
  };

  onTrajectoryStopMouseOver = (e: L.LeafletMouseEvent): void => {
    if (
      this.state.selectedIndex !== null &&
      this.state.selectedIndex !== undefined
    ) {
      this.setState({
        currentStopPoint: { lat: e.latlng.lat, lon: e.latlng.lng },
      });
    }
  };

  onTrajectoryStopMouseOut = (e: L.LeafletMouseEvent): void => {
    // this.setState({
    //   currentStopPoint: undefined,
    // });
  };

  isPtEqual = (
    pt1: { lat: number; lon: number },
    pt2: { lat: number; lon: number }
  ): boolean => {
    if (
      Math.abs(pt1.lat - pt2.lat) < 0.00001 &&
      Math.abs(pt1.lon - pt2.lon) < 0.00001
    )
      return true;
    return false;
  };

  belongsSegment = (
    st: { lat: number; lon: number },
    pt1: { lat: number; lon: number },
    pt2: { lat: number; lon: number },
    tolerance?: number
  ): boolean => {
    tolerance = tolerance === undefined ? 0.2 : tolerance;
    const hypotenuse = this.distance(pt1.lat, pt1.lon, pt2.lat, pt2.lon);
    const delta =
      this.distance(pt1.lat, pt1.lon, st.lat, st.lon) +
      this.distance(st.lat, st.lon, pt2.lat, pt2.lon) -
      hypotenuse;
    return delta / hypotenuse < tolerance;
  };

  getDistanceToPoint = (
    trajectory: { lat: number; lon: number }[],
    stop?: { lat: number; lon: number }
  ): number => {
    if (!stop) {
      return 0;
    }
    let fullLength = 0;
    for (let i = 1; i < trajectory.length; ++i) {
      if (this.isPtEqual(trajectory[i - 1], stop)) {
        return fullLength;
      }
      const ll = this.distance(
        trajectory[i - 1].lat,
        trajectory[i - 1].lon,
        trajectory[i].lat,
        trajectory[i].lon
      );
      if (this.isPtEqual(trajectory[i], stop)) return fullLength + ll;
      if (!this.isPtEqual(trajectory[i - 1], trajectory[i])) {
        if (
          this.belongsSegment(stop, trajectory[i - 1], trajectory[i], 0.0002)
        ) {
          return (
            fullLength +
            this.distance(
              trajectory[i - 1].lat,
              trajectory[i - 1].lon,
              stop.lat,
              stop.lon
            )
          );
        }
      }
      fullLength += ll;
    }
    return fullLength;
  };

  setCurrentStopPosition = (e: L.LeafletMouseEvent): void => {
    const { tripstops } = this.state;
    if (
      this.state.selectedIndex !== null &&
      this.state.selectedIndex !== undefined
    ) {
      const stop = (tripstops || []).find(
        (el: any) => el['id'] == this.state.selectedIndex
      );
      if (stop) {
        stop['distance'] = this.getDistanceToPoint(
          this.state.trajectory || [],
          this.state.currentStopPoint
        );
        this.forceUpdate();
      }
    }
  };

  getMarkers = () => {
    const {type, point, trajectory, currentStopPoint, tripstops, isEditable} = this.state;
    if (type === MapType.POINT) {
      return (
        point && [
          <Marker
            // для отключения перемещения маркеров, при isEditable = false
            draggable={isEditable}
            position={[point.lat, point.lon]}
            icon={MarkerMapPoint(false)}
            // для отключения перемещения маркеров, при isEditable = false
            onDragend={isEditable ? this.updatePointPosition : undefined}
          />,
        ]
      );
    } else if (this.state.type === MapType.TRAJECTORY) {
      if (trajectory) {
        return [
          <Polyline
            weight={6}
            key="trajectory"
            positions={trajectory.map(
              (point: { lat: number; lon: number }) =>
                [point.lat, point.lon] as [number, number]
            )}
            onClick={(e: L.LeafletMouseEvent) => {
              if (trajectory) {
                L.DomEvent.stopPropagation(e as any);
                for (let i = 0; i <= trajectory.length - 2; i++) {
                  const current = trajectory[i];
                  const next = trajectory[i + 1];
                  //добавляем дополнительную точку, если кликнули на полигон
                  if (
                    isBetween(
                      new LatLng(current.lat, current.lon),
                      new LatLng(next.lat, next.lon),
                      e.latlng
                    )
                  ) {
                    return this.setState({
                      trajectory: [
                        ...trajectory.slice(0, i + 1),
                        { lon: e.latlng.lng, lat: e.latlng.lat },
                        ...trajectory.slice(i + 1),
                      ],
                    });
                  }
                }
              }
            }}
          />,
          ...(this.props.fillPolygon
            ? [
                <Polygon
                  key="polygon"
                  positions={trajectory.map(
                    (point: { lat: number; lon: number }) =>
                      [point.lat, point.lon] as [number, number]
                  )}
                />,
              ]
            : []),
          ...(
            trajectory || []
          ).map((point: { lat: number; lon: number }, index: number) => (
            <Marker
              key={`marker-${index}`}
              index={index}
              draggable={true}
              position={[point.lat, point.lon]}
              icon={MarkerMapPoint(
                index !== this.state.selectedIndex,
                1,
                this.props.fillPolygon &&
                  (index === 0 || index === trajectory.length - 1)
                  ? `${index + 1}`
                  : undefined
              )}
              onDragend={this.updatePointPosition}
              onClick={this.onSelectMarker}
            />
          )),
        ];
      }
    } else if (this.state.type === MapType.TRAJECTORYSTOPS) {
      if (trajectory) {
        const res = [
          ...[
            <Polyline
              key="trajectory"
              positions={trajectory.map(
                (point: { lat: number; lon: number }) =>
                  [point.lat, point.lon] as [number, number]
              )}
              onmousemove={this.onTrajectoryStopMouseOver}
              onmouseout={this.onTrajectoryStopMouseOut}
            />,
          ],
          ...(
            (this.state.type === MapType.TRAJECTORYSTOPS && tripstops) ||
            []
          ).map((stop: any, index: number) => {
            return (
              (stop['distance'] != null && (
                <Marker
                  key={`marker-${stop['id']}`}
                  index={stop['id']}
                  draggable={false}
                  position={this.getPointOnTrajectory(
                    trajectory,
                    stop['distance']
                  )}
                  icon={MarkerMapPoint(
                    stop['id'] != this.state.selectedIndex,
                    stop['id'] != this.state.selectedIndex ? 0.5 : 1,
                    stop['stop_sequence']
                  )}
                  //onDragend={this.updatePointPosition}
                  //onClick={this.onSelectMarker}
                />
              )) ||
              undefined
            );
          }),
          ...[
            currentStopPoint ? (
              <Marker
                key={`marker-${this.state.selectedIndex}-sel`}
                draggable={true}
                position={[currentStopPoint.lat, currentStopPoint.lon]}
                icon={MarkerMapPoint(true, 0.5)}
                onClick={this.setCurrentStopPosition}
              />
            ) : (
              undefined
            ),
          ],
        ];
        return res;
      }
    }
    return undefined;
  };

  getStopList = (): IChoiceGroupOption[] => {
    const { tripstops } = this.props;
    return (tripstops || []).map(
      (elem: any): IChoiceGroupOption => {
        return {
          key: elem['id'],
          text: `${elem['stop_sequence']}: ${elem['stop_name']}`,
          onRenderField: (props, render) => {
            return <div>{render!(props)}</div>;
          },
        };
      }
    );
  };

  onStopSelChange = (
    ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
    option?: IChoiceGroupOption
  ): void => {
    // console.log(option && option.key);
    this.setState({ selectedIndex: parseInt((option && option.key) || '0') });
  };

  handleChangeSearchInput = async (newValue: string) => {
    let time = performance;
    
      axios
        .get(
          `search?q=${newValue}&format=json&addressdetails=1&limit=5&countrycodes=ru`
        )
        .then((res) => {
          let searchAddresses: any = [];
          res.data.forEach((item: any) => {
            searchAddresses.push({
              displayName: item.display_name,
              zoom:
                item.address.house_number ||
                item.address.mall ||
                item.address.building ||
                item.address.bus_stop ||
                item.address.suburb
                  ? 17
                  : item.address.road ||
                    item.address.pedestrian ||
                    item.address.city_district
                  ? 15
                  : 12,
              position: {
                lat: item.lat,
                lng: item.lon,
              },
            });
          });

          this.setState({
            searchAddresses,
            isVisibleSearchResult: true,
          });
        })
        .catch();
  }

  indexOfAll = (text: any, word: any) => {
    let start: any = 0
    let res: any = new Set()
    let index: any = -1
    do {
      index = text.toLowerCase().indexOf(word.toLowerCase(), start)
      if (index >=0) {
        let old = text.substring(index, index + word.length)
        res.add(old)
        start = index+1
      }
    } while (index !== -1)
    return [...res]
  }

  replaceElements = (elements: string[], word: string, index: number) => {
    return elements.reduce((t: string[], v: string) => {
      if (/^\$el\[(\d{1,})\]#$/.test(v)) {
        return [...t, v]
      }
      let res = v.replace(new RegExp(word, 'g'), `$(split)#$el[${index}]#$(split)#`)
      return [...t, ...res.split('$(split)#')]
    }, []).filter(x=>x.length>0)
  }

  addBlackSubstring = (text: string, search: string) => {
    search = search.trim()
    if (search.length === 0) {
      return [text]
    }
    let words: string[] = search.split(/[\s,]+/)
    let search_words = words.reduce((t: string[], v: string)=>{
      return [...t, ...this.indexOfAll(text, v)]
    },[])
    search_words = search_words.sort((a:string, b: string) => b.length - a.length)
    let elements: string[] = [text]
    search_words.forEach((word: string, index: number) => {
      elements = this.replaceElements(elements, word, index)
    });
  
    let res: any[] = elements.map((item, index) => {
      if (/^\$el\[(\d{1,})\]#$/.test(item)) {
        let match: any = item.match(/^\$el\[(\d{1,})\]#$/)
        if (match !== null) {
          let word = search_words[match[1]]
          return <BlackText key={index}>{word}</BlackText>
        }
        return <BlackText key={index}>{item}</BlackText>
      }
      return item
    })
    return res
  };

  onRenderAddressCell = (item: any): JSX.Element => {
      return (
        <SearchResultLine
          onClick={() => {
            this.props.handleChangeMapSettings({
              zoom: item.zoom,
              center: item.position,
            });
            this.setState({
              searchValue: item.displayName,
              isVisibleSearchResult: false,
            });
              this.setState({
                selectedAddressCenter: [item.position.lat, item.position.lng],
              });
          }}
          data-is-focusable={true}
        >
          {this.addBlackSubstring(item.displayName, this.state.searchValue)}
        </SearchResultLine>
      );
  };

  handleDrawPolygon = (polygon: any) => {
    let coordinates: any;
    this.setState({
      mode: 'polygon',
      mapLayers: {
        stops: false,
        vehicles: true,
        routes: false,
        incidents: false
      },
    });
    
    if (polygon.layerType === 'circle') {
      coordinates = circleToPolygon(
        polygon.layer.toGeoJSON().geometry.coordinates,
        polygon.layer._mRadius
      ).coordinates;  
      this.setState({
        coordinates,
      });
    } else {
      coordinates = polygon.layer.toGeoJSON().geometry.coordinates;
      this.setState({
        coordinates: polygon.layer.toGeoJSON().geometry.coordinates,
      });
    } 

    this.setState({polygon: {
      type: polygon.layerType,
      coordinates: coordinates[0].map((coords: any) => ([coords[1], coords[0]])),
    }})
  };

  clearAllLayers = () => {
    const layerContainer = this.editControl.current.leafletElement.options.edit
      .featureGroup;
    const layers = layerContainer._layers;
    const layersIds = Object.keys(layers);
    layersIds.forEach((id: string) => {
      const layer = layers[id];
      layerContainer.removeLayer(layer);
    });
    this.setState({
      mode: '',
      mapLayers: {
        stops: true,
        vehicles: false,
        routes: true,
        incidents: false
      },
      coordinates: null,
    });
  };

  toggleDrawingModeHandler = () => {
    this.setState((prev) => ({
      drawingMode: !prev.drawingMode,
    }));
  };

  render() {
    const { mapSettings, handleChangeMapSettings } = this.props;
    const {point, trajectory, type, tripstops, isEditable} = this.state;

    return (
      <Modal isOpen={true}>
        <Stack horizontal>
          <StyledModalBody>
            <TopLeftPanel>
              <FocusZone direction={FocusZoneDirection.vertical}>
                <SearchBox
                  styles={{
                    root: {
                      background: 'rgba(255,255,255, .9)',
                      border: 'none',
                    },
                    field: {
                      selectors: {
                        ':focus': {
                          background: '#ffffff !important',
                        },
                      },
                    },
                    clearButton: {
                      background: '#ffffff !important',
                    },
                  }}
                  placeholder={''}
                  value={this.state.searchValue}
                  onChange={(newValue) => {
                    this.setState({
                      searchValue: newValue,
                    });
                  }}
                  onChanged={this.handleChangeSearchInput}
                  onClear={() => {
                    this.setState({
                      isVisibleSearchResult: false,
                    });
                  }}
                  onClick={() =>
                    this.handleChangeSearchInput(this.state.searchValue)
                  }
                />
                <SearchResultWrapper
                  style={{
                    opacity: this.state.isVisibleSearchResult ? 1 : 0,
                    height: this.state.isVisibleSearchResult ? 'auto' : 0,
                  }}
                >
                  <List
                    items={[
                      ...this.state.searchAddresses,
                    ]}
                    onRenderCell={this.onRenderAddressCell}
                  />
                </SearchResultWrapper>
              </FocusZone>
            </TopLeftPanel>
            {
              <TopRightPanel>
                {!isEditable && 
                  <MapButtonBG
                    onClick={() => this.props.onClose && this.props.onClose()}
                  >
                    <Icon iconName="CalculatorMultiply" />
                  </MapButtonBG>}
                {
                  this.props.isPolygon &&
                  <MapButtonBG>
                    <Icon
                      onClick={this.toggleDrawingModeHandler}
                      iconName="Pentagon"
                      styles={{
                        root: {color: this.state.drawingMode ? theme.colors.lightBlue : ''},
                      }}
                    />
                  </MapButtonBG>
                }
                  {this.state.drawingMode && (
                    <DeleteButton>
                      <Icon onClick={this.clearAllLayers} iconName="Delete" />
                    </DeleteButton>
                  )}
              </TopRightPanel>
            }
            <BottomRightPanel>
              <MapButtonBG
                onClick={() => {
                  handleChangeMapSettings({ zoom: mapSettings.zoom + 1 });
                }}
              >
                <Icon iconName="CalculatorAddition" />
              </MapButtonBG>
              <MapButtonBG
                onClick={() => {
                  handleChangeMapSettings({ zoom: mapSettings.zoom - 1 });
                }}
              >
                <Icon iconName="CalculatorSubtract" />
              </MapButtonBG>
            </BottomRightPanel>
            <MapWrapper isPanelOpen={this.state.drawingMode} >
            <Map
              zoomControl={false}
              center={mapSettings.center}
              zoom={mapSettings.zoom}
              style={{ zIndex: 1 }}
              onzoomend={(event: L.LeafletEvent) => {
                this.handleGetBounds(event);
              }}
              ondragend={(event: L.DragEndEvent) => {
                this.handleGetBounds(event);
              }}
              minZoom={2}
              maxZoom={18}
              ref={this.mapRef}
              // для того, чтобы убрать перемещение маркера, при isEditable = false
              onClick={isEditable && !this.props.isPolygon ? this.onMapClick : undefined}
              
            >
              <TileLayer url={process.env.REACT_APP_MAP_TILES as string} />
              {this.getMarkers()}
              {
                this.props.value && !this.state.polygon?.coordinates &&
                  <Polygon color={theme.colors.themeSecondary} positions={this.props.value} pathOptions={{zIndex: 10}}  />
              }
              {
                !!this.props.zone?.geometry?.coordinates?.length &&
                  <Polyline positions={this.props.zone.geometry.coordinates[0].map((pt: any) => new LatLng(pt[0], pt[1]))} interactive={false} color={'red'} />
              }
              {
                this.props.zone &&
                  <Pane name='route-points' style={{ zIndex: 500 }}>
                    {
                      this.props.value.map((point: any) => (
                      <CircleMarker center={{lat: point[1], lng: point[0]}} radius={5} color={theme.colors.lightBlue}
                                    fillOpacity={1}></CircleMarker>
                    ))
                    }
                    {
                      <Polyline color={theme.colors.themeSecondary} positions={this.props.value.map((point: any) => ([point[1], point[0]]))} pathOptions={{zIndex: 10}}  />
                    }
                  </Pane>
              }
              <FeatureGroup>
                <EditControl
                  position={'topright'}
                  draw={{
                    rectangle: true,
                    polyline: false,
                    polygon: true,
                    circle: true,
                    marker: false,
                    circlemarker: false,
                  }}
                  onCreated={(event: any) => {
                    this.handleDrawPolygon!(event);
    
                    this.setState({
                      drawingMode: false,
                      selectedAddressCenter: undefined,
                    });
                  }}
                  onDrawStart={this.clearAllLayers}
                  edit={{
                    edit: false,
                    remove: false,
                  }}
                  ref={this.editControl}
                />
              </FeatureGroup>
            </Map>
            </MapWrapper>
          </StyledModalBody>
          {this.state.type === MapType.TRAJECTORYSTOPS && (
            <StopsContainer>
              <StopsTitle>Остановки</StopsTitle>
              <Stack
                styles={{
                  root: {
                    padding: '0 20px',
                    height: '545px',
                    overflowY: 'auto',
                  },
                }}
              >
                <ChoiceGroup
                  options={this.getStopList()}
                  onChange={this.onStopSelChange}
                />
              </Stack>
            </StopsContainer>
          )}
        </Stack>
        {
          isEditable &&
          <Stack
            horizontal
            horizontalAlign={'end'}
            tokens={{childrenGap: 10}}
            styles={{root: {padding: '10px;'}}}
          >
            <PrimaryButton
              text="Применить"
              disabled={
                ((type === MapType.POINT && !this.state.point) ||
                  (type === MapType.TRAJECTORY && trajectory!.length < 2 && !this.props.isPolygon) ||
                  (!this.state.polygon && this.props.isPolygon))
              }
              onClick={() => {
                this.props.onAccept &&
                this.props.onAccept(point || tripstops || trajectory || this.state.polygon);
              }}
            />
            <DefaultButton
              text="Отмена"
              onClick={() => this.props.onClose && this.props.onClose()}
            />
          </Stack>
        }
      </Modal>
    );
  }
}

export default mapController(MapForm);
